import scssVars from '@/styles/vars.scss';
import { localeData } from '../../common/services/localeService';
const texts = require('../../../texts');

export const analyticsChartColors = {
    likes: ["#C32737", "#4D77A6", "#468437"],
    analyticsChartTable: ["#468437", "#C32737", "#4D77A6"],
    clicks: ["rgba(195, 39, 55, 1)", "rgba(195, 39, 55, 0.8)", "rgba(195, 39, 55, 0.6)", "rgba(195, 39, 55, 0.4)", "rgba(195, 39, 55, 0.3)", "rgba(195, 39, 55, 0.2)", "rgba(195, 39, 55, 0.1)", "rgba(195, 39, 55, 0.1)"],
    cleaning: ["rgba(195, 39, 55, 1)", "rgba(195, 39, 55, 0.8)", "rgba(195, 39, 55, 0.6)", "rgba(195, 39, 55, 0.4)", "rgba(195, 39, 55, 0.3)", "rgba(195, 39, 55, 0.2)", "rgba(195, 39, 55, 0.1)", "rgba(195, 39, 55, 0.1)"],
    maintenance: ["rgba(77, 119, 166, 1)", "rgba(77, 119, 166, 0.8)", "rgba(77, 119, 166, 0.6)", "rgba(77, 119, 166, 0.4)", "rgba(77, 119, 166, 0.3)", "rgba(77, 119, 166, 0.2)", "rgba(77, 119, 166, 0.1)", "rgba(77, 119, 166, 0.1)"],
}

export const chartColors = {
    avg_score: { line: scssVars.wedgewoodBlue, background: "" },
    complaints: { line: scssVars.persianRed, background: "" },
    visits: { line: scssVars.bouquet, background: "" },
    response_time_SLA: { line: scssVars.darkCyan, background: "" },
    complaints_vs_visits: { line: scssVars.deepSkyBlue, background: "" },
    time_saved: { line: scssVars.saffron, background: "" },
    arrivals: { line: scssVars.goblinGreen, background: "" },
    unnecessary_arrivals: { line: scssVars.seaGreen, background: "" }
}

export const byHourTableConst = [
    { color: scssVars.red, text: 'complaints' },
    { color: scssVars.darkerGreen, text: 'cleaner_arrivals' },
    { color: scssVars.blue, text: 'visits' },
];

export const overviewChartOptions = {
    hover: {
        onHover: function (e) {
            var point = this.getElementAtEvent(e);
            if (point.length) e.target.style.cursor = "pointer";
            else e.target.style.cursor = "default";
        },
    },
    maintainAspectRatio: false,
    legend: { display: false },
    layout: { padding: { top: 10 } },
    tooltips: {
        callbacks: {
            label: (tooltipItem, chartData) => {
                const { datasets } = chartData;
                const { label } = datasets[tooltipItem.datasetIndex];
                // Trendline datasets use label like "trendline_visits" - no translation exists; use base label and show as trend
                const isTrendline = typeof label === 'string' && label.startsWith('trendline_');
                const baseLabel = isTrendline ? label.replace('trendline_', '') : label;
                const translated = texts[localeData.language] && texts[localeData.language][baseLabel];
                const displayName = translated != null ? translated : baseLabel;
                const suffix = isTrendline ? ` (${texts[localeData.language]?.trend || 'Trend'})` : '';
                const labelStr = `${tooltipItem.label} / ${displayName}${suffix}: ${tooltipItem.yLabel}`;
                return labelStr;
            },
            title: (tooltipItems, chartData) => '',
        },
        bodyFontSize: 15,
        backgroundColor: scssVars.lightGrey,
        titleFontColor: scssVars.blackBlue,
        bodyFontColor: scssVars.blackBlue,
        caretPadding: 20,
        displayColors: false,
        rtl: localeData.isRTL
    },
    scales: {
        xAxes: [{ gridLines: { color: "rgba(0, 0, 0, 0)" }}],
    }
}

function _overviewTooltipLabel(tooltipItem, chartData) {
    const { datasets } = chartData;
    const { label } = datasets[tooltipItem.datasetIndex];
    const isTrendline = typeof label === 'string' && label.startsWith('trendline_');
    const baseLabel = isTrendline ? label.replace('trendline_', '') : label;
    const translated = texts[localeData.language] && texts[localeData.language][baseLabel];
    const displayName = translated != null ? translated : baseLabel;
    const suffix = isTrendline ? ` (${texts[localeData.language]?.trend || 'Trend'})` : '';
    return `${tooltipItem.label} / ${displayName}${suffix}: ${tooltipItem.yLabel}`;
}

function _overviewExternalTooltip(tooltipModel) {
    let el = document.getElementById('overview-line-tooltip');
    if (!el) {
        el = document.createElement('div');
        el.id = 'overview-line-tooltip';
        el.style.cssText =
            'position:fixed;pointer-events:none;padding:6px 10px;border-radius:4px;font-size:12px;' +
            'white-space:nowrap;z-index:99999;transition:opacity 0.15s;';
        document.body.appendChild(el);
    }

    if (tooltipModel.opacity === 0) {
        el.style.opacity = '0';
        return;
    }

    const bgColor = scssVars.lightGrey || '#f5f5f5';
    const textColor = scssVars.blackBlue || '#2c2c3a';
    el.style.backgroundColor = bgColor;
    el.style.color = textColor;

    const lines = (tooltipModel.body || []).map(b => b.lines).flat();
    el.innerHTML = lines.map(l => `<div>${l}</div>`).join('');

    const canvas = this._chart.canvas;
    const rect = canvas.getBoundingClientRect();
    let left = rect.left + tooltipModel.caretX;
    let top = rect.top + tooltipModel.caretY;

    const ttWidth = el.offsetWidth || 120;
    const ttHeight = el.offsetHeight || 30;
    if (left + ttWidth + 8 > window.innerWidth) left = left - ttWidth - 8;
    if (top + ttHeight + 8 > window.innerHeight) top = top - ttHeight - 8;

    el.style.left = left + 8 + 'px';
    el.style.top = top - ttHeight - 8 + 'px';
    el.style.opacity = '1';
}

export const overviewLineChartsOptions = {

    maintainAspectRatio: false,
    legend: { display: false },
    layout: { padding: { top: 10 } },
    elements: { point: { radius: 0 } },
    tooltips: {
        enabled: false,
        custom: _overviewExternalTooltip,
        callbacks: {
            label: _overviewTooltipLabel,
            title: () => '',
        },
        mode: 'nearest',
        intersect: true,
    },
    scales: {
        xAxes: [{ gridLines: { color: "rgba(0, 0, 0, 0)" }, barPercentage: 0.2, display: false }],
        yAxes: [{ display: false, ticks: { min: 0, max: 105 } }]
    }
};

export const overviewLineChartsColors = {
    avg_score: '#5781AE',
    complaints: '#D64342',
    response_time_SLA: '#D75E41',
    time_saved: '#F6BC45',
    avg_score_static: '#507CAC',
    complaints_static: '#D33736',
    response_time_SLA_static: '#D65A3B',
    time_saved_static: '#F5B839',
};

export const trendArrowsBackgroundColors = {
    avg_score: '#DCE4EE',
    complaints: '#F5D6D5',
    response_time_SLA: '#F7DDD7',
    time_saved: '#FDF0D6',
    avg_score_static: '#83A2C4',
    complaints_static: '#E07170',
    response_time_SLA_static: '#E18A74',
    time_saved_static: '#F8CD72',
};

export const analyticsTableInfo = {
    header: 'visits data',
    head: ['displayName', 'score', 'complaints', 'arrivals', 'unnecessaryArrivals', 'visits', 'avgResponseTime', 'ratio', 'topComplaints', 'supervisors', 'counterCalls', 'cleandexCalls', 'manualCalls', 'exposures', 'likes', 'maintenanceComplaints']
};

export const analyticsTableInfoNarrowed = {
    header: 'visits data',
    head: ['displayName', 'complaints', 'arrivals', 'visits', 'avgResponseTime', 'topComplaints']
};

export const infoCards = [
    {
        label: 'Avg.Score',
        name: 'avg_score',
        iconUrl: 'assets/performance/avg_score-icon.svg',
        text: 'N/A',
        color: 'red',
        isActive: false
    },
    {
        label: 'Time Saved',
        name: 'time_saved',
        iconUrl: 'assets/performance/clock.svg',
        text: 'N/A',
        color: 'red',
        isActive: false
    },
    {
        label: 'Est.ROI',
        name: 'est_ROI',
        iconUrl: 'assets/performance/dollar.svg',
        text: 'N/A',
        color: 'red',
        isActive: false
    }
];

export const buttonsInfo = [
    {
        label: 'Avg.Score',
        name: 'avg_score',
        iconUrl: 'assets/performance/avg_score-icon.svg',
        color: 'wedgewood-blue',
        isActive: true,
        text: 'N/A'
    },
    {
        label: 'Complaints',
        name: 'complaints',
        iconUrl: 'assets/performance/icons-complaint.svg',
        activeIconUrl: 'assets/performance/icons-complaint_white.svg',
        color: 'persian-red',
        isActive: false,
        text: 'N/A'
    },
    {
        label: 'cleaner_arrivals',
        name: 'arrivals',
        iconUrl: 'assets/performance/cleaner_arrival-icon.svg',
        activeIconUrl: 'assets/performance/cleaner_arrival_white-icon.svg',
        color: 'goblin-green',
        isActive: false,
        text: 'N/A'
    },
    {
        label: 'unnecessary_arrivals',
        name: 'unnecessary_arrivals',
        iconUrl: 'assets/performance/cleaner_arrival-icon.svg',
        activeIconUrl: 'assets/performance/cleaner_arrival_white-icon.svg',
        color: 'sea-green',
        isActive: false,
        text: 'N/A'
    },
    {
        label: 'Visits',
        name: 'visits',
        iconUrl: 'assets/performance/icons-visits.svg',
        activeIconUrl: 'assets/performance/icons-visits_white.svg',
        color: 'bouquet',
        isActive: false,
        text: 'N/A',
        isAmended: 0
    },
    {
        label: 'Response time (SLA)',
        name: 'response_time_SLA',
        iconUrl: 'assets/performance/icons-timer.svg',
        activeIconUrl: 'assets/performance/icons-timer_white.svg',
        color: 'dark-cyan',
        isActive: false,
        text: 'N/A'
    },
    {
        label: 'Complaints vs. Visits',
        name: 'complaints_vs_visits',
        iconUrl: null,
        color: 'deep-sky-blue',
        isActive: false,
        text: 'N/A'
    },
    {
        label: 'Time Saved',
        name: 'time_saved',
        iconUrl: 'assets/performance/clock.svg',
        activeIconUrl: 'assets/performance/clock_white.svg',
        text: 'N/A',
        color: 'saffron',
        isActive: false
    }
];

export const serviceLogBarItemsInitialMaintenance = [
    {
        label: 'avg_score',
        name: 'avg_score',
        iconUrl: 'assets/performance/avg_score-icon.svg',
        color: 'cyan',
        text: 'N/A'
    },
    {
        label: 'complaints',
        name: 'complaints',
        iconUrl: 'assets/performance/icons-complaint.svg',
        activeIconUrl: 'assets/performance/icons-complaint_white.svg',
        color: 'red',
        text: 'N/A'
    },
    {
        text: 'N/A',
        label: 'maintenance_arrivals',
        name: 'maintenanceArrivals',
        iconUrl: 'assets/performance/maintenance-arrivals_purple.svg',
        
    },
    {
        label: 'visits',
        name: 'visits',
        iconUrl: 'assets/performance/icons-visits.svg',
        activeIconUrl: 'assets/performance/icons-visits_white.svg',
        color: 'blue',
        text: 'N/A'
    },
];

export const serviceLogBarItemsInitialCleaning = [
    {
        label: 'avg_score',
        name: 'avg_score',
        iconUrl: 'assets/performance/avg_score-icon.svg',
        color: 'cyan',
        text: 'N/A'
    },
    {
        label: 'complaints',
        name: 'complaints',
        iconUrl: 'assets/performance/icons-complaint.svg',
        activeIconUrl: 'assets/performance/icons-complaint_white.svg',
        color: 'red',
        text: 'N/A'
    },
    {
        label: 'counterCalls',
        name: 'counterCalls',
        iconUrl: 'assets/performance/icons-counter_calls.svg',
        activeIconUrl: '',
        color: 'orange',
        text: 'N/A'
    },
    {
        label: 'cleandexCalls',
        name: 'cleandexCalls',
        iconUrl: 'assets/performance/cleandex_calls-icon.svg',
        activeIconUrl: '',
        color: 'orange',
        text: 'N/A'
    },
    {
        label: 'manualCalls',
        name: 'manualCalls',
        iconUrl: 'assets/performance/icons-counter_calls.svg',
        activeIconUrl: '',
        color: 'orange',
        text: 'N/A'
    },
    {
        label: 'cleaner_arrivals',
        name: 'arrivals',
        iconUrl: 'assets/performance/cleaner_arrival-icon.svg',
        text: 'N/A'
    },
    {
        text: 'N/A',
        label: 'supervisor_arrival',
        name: 'supervisor_arrival',
        iconUrl: 'assets/performance/supervisor_arrival-icon.svg',
    },
    {
        label: 'visits',
        name: 'visits',
        iconUrl: 'assets/performance/icons-visits.svg',
        activeIconUrl: 'assets/performance/icons-visits_white.svg',
        color: 'blue',
        text: 'N/A'
    },
    {
        label: 'response_time_SLA',
        name: 'response_time_SLA',
        iconUrl: 'assets/performance/icons-timer.svg',
        activeIconUrl: 'assets/performance/icons-timer_white.svg',
        color: 'pink',
        text: 'N/A'
    }
];

export const infoBarItems = [
    {
        text: 'N/A',
        label: 'avg_score',
        name: 'avg_score',
        iconUrl: 'assets/performance/avg_score-icon.svg',
    },
    {
        text: 'N/A',
        label: 'complaints',
        name: 'complaints',
        iconUrl: 'assets/performance/icons-complaint.svg',
    },
    {
        text: 'N/A',
        label: 'cleaner_arrivals',
        name: 'arrivals',
        iconUrl: 'assets/performance/cleaner_arrival-icon.svg',
    },
    {
        text: 'N/A',
        label: 'unnecessary_arrivals',
        name: 'unnecessary_arrivals',
        iconUrl: 'assets/performance/cleaner_arrival-icon.svg',
    },
    {
        text: 'N/A',
        label: 'visits',
        name: 'visits',
        iconUrl: 'assets/performance/icons-visits.svg',
        isAmended: 0
    },
    {
        text: 'N/A',
        label: 'response_time_SLA',
        name: 'response_time_SLA',
        iconUrl: 'assets/performance/icons-timer.svg',
    },
    {
        text: 'N/A',
        label: 'exposures',
        name: 'exposures',
        iconUrl: 'assets/performance/man-exposures.svg',
    },
    {
        text: 'N/A',
        label: 'counterCalls',
        name: 'counterCalls',
        iconUrl: 'assets/performance/icons-counter_calls.svg',
    },
    {
        text: 'N/A',
        label: 'cleandexCalls',
        name: 'cleandexCalls',
        iconUrl: 'assets/performance/cleandex_calls-icon.svg',
    },
    {
        text: 'N/A',
        label: 'manualCalls',
        name: 'manualCalls',
        iconUrl: 'assets/performance/icons-counter_calls.svg',
    },
    {
        text: 'N/A',
        label: 'maintenance',
        name: 'maintenanceComplaint',
        iconUrl: 'assets/performance/icons-complaint_blue.svg',
    },
    {
        text: 'N/A',
        label: 'maintenance_arrivals',
        name: 'maintenanceArrivals',
        iconUrl: 'assets/performance/maintenance-arrivals_purple.svg',
    },
    {
        text: 'N/A',
        label: 'supervisor_arrival',
        name: 'supervisor_arrival',
        iconUrl: 'assets/performance/supervisor_arrival-icon.svg',
    },
];

/** A copy of the cards with one left out. Callers that edit a card must clone the result first. */
export function infoBarItemsExcept(name) {
    return infoBarItems.filter((item) => item.name !== name)
}

export const trendArrowColors = {
    avg_score: {
        up: "green",
        down: "red",
    },
    exposures:{
        up: "green",
        down: "red",
    },
    complaints: {
        up: "red",
        down: "green",
    },
    response_time_SLA: {
        up: "red",
        down: "green",
    },
    time_saved: {
        up: "green",
        down: "red",
    },
}